import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from '../../colors';
import { getInputSizeStyles, getInputVariantStyles } from './input-styles';
import type { InputStyleProps, StyledInputProps } from './types';

export const Container = styled.label<{
  $fullWidth?: boolean;
  $styleProps?: InputStyleProps | undefined;
}>`
  display: inline-flex;
  align-items: center;
  position: relative;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  margin: ${({ $styleProps }) => $styleProps?.margin ?? '0'};
`;

export const IconWrapper = styled.span<{
  position: 'start' | 'end';
  $styleProps?: InputStyleProps | undefined;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  color: ${({ $styleProps }) => $styleProps?.iconColor ?? colors.gray[500]};
  ${({ position }) =>
    position === 'start'
      ? css`
          left: 8px;
        `
      : css`
          right: 8px;
        `}
`;

export const StyledInput = styled.input<StyledInputProps>`
  width: 100%;
  border-radius: ${({ $styleProps }) => $styleProps?.borderRadius ?? '5px'} !important;
  transition: all 0.2s ease-in-out;
  outline: none;
  border: 1px solid transparent !important;
  color: ${({ $styleProps }) => $styleProps?.color ?? colors.gray[800]} !important;
  font-size: ${({ $styleProps }) => $styleProps?.fontSize ?? 'inherit'};
  padding: ${({ $styleProps }) => $styleProps?.padding ?? 'inherit'};
  margin: ${({ $styleProps }) => $styleProps?.margin ?? '0'};
  box-shadow: none !important;
  outline: none !important;

  ${({ $size = 'medium', $styleProps }) => {

    if ($styleProps?.padding) return '';
    return getInputSizeStyles($size);
  }}

  ${({ $hasStartIcon }) =>
    $hasStartIcon &&
    css`
      padding-left: 32px !important;
    `}

  ${({ $hasEndIcon }) =>
    $hasEndIcon &&
    css`
      padding-right: 32px !important;
    `}

  ${({ $variant = 'outline', $error = false, $styleProps }) =>
    getInputVariantStyles($variant, $error, $styleProps)}

  &:disabled {
    background-color: ${({ $styleProps }) => $styleProps?.backgroundColor ?? colors.gray[100]};
    cursor: not-allowed;
  }

  &[readonly] {
    background-color: ${({ $styleProps }) =>
      $styleProps?.backgroundColor ?? colors.white} !important;
  }
`;